import OldHomePage from '@app/shop/OldHomePage';
import { IOldHomeServerProps } from '@base/shop/interface';

const Page: Globals.NextPage<{ serverProps: IOldHomeServerProps }> = ({ serverProps }) => {
    return <OldHomePage {...serverProps} />
};

Page.pageConf = {
    pageCode: 'promotionalSale',
    bodyClassName: 'bg-light',
};

export default Page;

export { getServerSideProps } from '@base/shop/services';